export default __webpack_public_path__ + "static/media/k.84e7ce67.png";